import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      meta: {
        requiresAuth: false
      },
      component: Home
    },
    {
      path: '/timeout',
      name: 'timeout',
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "timeout" */ './views/Timeout.vue')
    },
    {
      path: '/grantees',
      name: 'grantees',
      meta: {
        requiresAuth: true,
        authRoles: ['fhv-admin']
      },
      component: () => import(/* webpackChunkName: "grantees" */ './views/GranteeList.vue')
    },
    {
      path: '/providers',
      name: 'providers',
      meta: {
        requiresAuth: true,
        authRoles: ['fhv-admin']
      },
      component: () => import(/* webpackChunkName: "providers" */ './views/ProviderList.vue')
    },
    {
      path: '/provider/:id',
      name: 'provider',
      meta: {
        requiresAuth: true,
        authRoles: ['fhv-admin']
      },
      component: () => import(/* webpackChunkName: "providerDetail" */ './views/ProviderDetail.vue'),
      props: true
    },
    {
      path: '/participant/visits/:id',
      name: 'visits',
      meta: {
        requiresAuth: true,
        authRoles: ['fhv-admin']
      },
      component: () => import(/* webpackChunkName: "participantVisit" */ './views/ParticipantVisits.vue'),
      props: true
    },
    {
      path: '/grants',
      name: 'grants',
      meta: {
        requiresAuth: true,
        authRoles: ['fhv-admin']
      },
      component: () => import(/* webpackChunkName: "grants" */ './views/GrantList.vue')
    },
    {
      path: '/search',
      name: 'search',
      meta: {
        requiresAuth: true,
        authRoles: ['fhv-admin', 'redcap-user']
      },
      component: () => import(/* webpackChunkName: "search" */ './views/PersonSearch.vue')
    },
    {
      path: '/users',
      name: 'users',
      meta: {
        requiresAuth: true,
        authRoles: ['fhv-admin', 'redcap-search']
      },
      component: () => import(/* webpackChunkName: "users" */ './views/UserManagement.vue')
    },

    {
      path: '/settings',
      name: 'settings',
      meta: {
        requiresAuth: true,
        authRoles: ['fhv-admin', 'redcap-search']
      },
      component: () => import(/* webpackChunkName: "settings" */ './views/ApplicationSettings.vue')
    },

    {
      path: '/redcap',
      name: 'redcap',
      meta: {
        requiresAuth: true,
        authRoles: ['fhv-admin']
      },
      component: () => import(/* webpackChunkName: "redcap" */ './views/REDCapList.vue')
    },

    {
      path: '/redcap/events/:id',
      name: 'redcapevents',
      meta: {
        requiresAuth: true,
        authRoles: ['fhv-admin']
      },
      component: () => import(/* webpackChunkName: "redcapevents" */ './views/REDCapDetail.vue'),
      props: true
    },

    {
      path: '/redcap/closureEvents/:id',
      name: 'redcapClosureEvents',
      meta: {
        requiresAuth: true,
        authRoles: ['fhv-admin']
      },
      component: () => import(/* webpackChunkName: "redcapClosureEvents" */ './views/REDCapClosureDetail.vue'),
      props: true
    },

    {
      path: '/unauthorized',
      name: 'unauthorized',
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "unauthorized" */ './views/Unauthorized.vue')
    },

    {
      path: '/requestaccess',
      name: 'requestaccess',
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "requestaccess" */ './views/RequestAccess.vue')
    },

    {
      path: '/accessqueue',
      name: 'accessqueue',
      meta: {
        requiresAuth: true,
        authRoles: ['fhv-admin']
      },
      component: () => import(/* webpackChunkName: "requestaccess" */ './views/RequestAccessList.vue')
    },

    {
      path: '*', 
      component: Home
    }
  ]
})

// router.beforeEach((to, from, next) => {
//   if (to.matched.some(record => record.meta.requiresAuth)) {
//     if (router.app.$keycloak.authenticated) {
//       if (to.meta.authRoles) {
//         let hasRole = false
//         for (var i = 0; i < to.meta.authRoles.length; i++) {
//           if (router.app.$keycloak.hasResourceRole(to.meta.authRoles[i])) {
//             hasRole = true;
//           }
//         }
//         if (hasRole) {
//           next()
//         } else {
//           router.push('unauthorized') 
//         }
//       } else {
//         next();
//       }
//     } else {
//       const loginUrl = router.app.$keycloak.createLoginUrl()
//       window.location.replace(loginUrl)
//     }
//   } else {
//     next()
//   }
// })

export default router